<div class="app-container">
  <app-header class="app-header" (toggleSideNav)="toggleSidenav()"></app-header>
  <mat-sidenav-container class="app-content-container">
    <mat-sidenav mode="side" [opened]="sidenavOpened()" class="app-sidenav-container" ppSidenavAutosize>
      <!--
        The designer brings its own navigation — its six sections are not routes of this
        application and the ordinary sidenav, which reads `router.config`, cannot see them. Swapping
        rather than appending is what makes the designer a mode rather than a seventh screen.
      -->
      @if (designRouteService.isDesignRoute()) {
        <pp-design-sidenav></pp-design-sidenav>
      } @else {
        <app-sidenav></app-sidenav>
      }
    </mat-sidenav>
    <mat-sidenav-content class="app-sidenav-content">
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
  <app-footer class="app-footer"></app-footer>
</div>
